import React from "react";
import { useRouteLoaderData } from "react-router-dom";
import { imageUpdateImage } from "../../../../../api/image";
import ImageForm from "./ImageForm";

const imageUpdateAction = async ({ request }) => {
  const formData = await request.formData();

  const submission = {
    imageEntityId: formData.get("imageEntityId"),
    imageName: formData.get("imageName"),
    imageCredit: formData.get("imageCredit"),
    imageLabel: formData.get("imageLabel"),
    imageType: formData.get("imageType"),
    imageUrl: formData.get("imageUrl"),
  };

  return await imageUpdateImage({ ...submission });
};

const ImageUpdateForm = () => {
  const { image } = useRouteLoaderData("adminImage");

  return <ImageForm image={image}/>;
};

export { imageUpdateAction };
export default ImageUpdateForm;